import React, { useEffect} from 'react';
import { Query } from 'react-apollo';
import { makeStyles } from '@material-ui/core/styles';
import {GET_EXERCISE} from "graphql/admin/curriculum";
import Spin from 'components/common/Spin';
import Preview from "./components/Preview";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'fixed',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(248, 249, 252, .9)',
    backdropFilter: 'blur(8px)',
    paddingTop: 60,
    paddingBottom: 60,
    zIndex: 99
  },
  content: {
    overflow: 'auto',
    height: 'calc(100vh - 80px)',
    paddingRight: 16,
  },
  header: {
    '& button': {
      position: 'absolute',
      top: 10,
      right: 20,
    },
  },
}));


const ViewExercise = ({ history, match: { params: { id, moduleId }} }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <IconButton onClick={() => history.goBack()}>
          <CloseIcon fontSize={"large"} />
        </IconButton>
      </div>
      <Container maxWidth="md">
        <Grid container alignItems="center">
          <Grid item xs={12} sm={12}>
            <div className={classes.content}>
              <Query query={GET_EXERCISE} variables={{ id }}>
                {({ data, loading, error}) => {
                  if (loading) return <Spin spinning />;
                  if (error) return 'Error';

                  const exercise = data.exercises[0];

                  return (
                    <Preview module={exercise.module} data={exercise} />
                  )
                }}
              </Query>
            </div>
          </Grid>
        </Grid>
      </Container>
    </div>
  )
};

export default ViewExercise;
